import styled from "styled-components";
import { RedBarBase } from "./RedBase";
export const RedDividerBar = styled(RedBarBase) `
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "2px"};

`;
